import RegisterFinal from "./RegisterFinal";

export default RegisterFinal;
